{
  "reminder": {
    "create_reminder": "Create Reminder",
    "reminder": "Reminder",
    "no_reminder_for_list": "No reminder for current list",
    "send_to": "Send To",
    "actions": "Actions",
    "dismiss": "Dismiss",
    "dismiss_confirm_title": "Are you sure you want to dismiss the reminder?",
    "dismiss_confirm_content": "Click confirm to dismiss reminder.",
    "remove_reminder": "Remove reminder",
    "remove_confirm_title": "Are you sure you want to remove this reminder?",
    "remove_confirm_content": "Click confirm to remove reminder.",
    "create_reminder_modal": "Create Reminder",
    "update_reminder_modal": "Update Reminder",
    "send_a": "Send a",
    "reminder_text": "reminder",
    "days": "days",
    "to": "to",
    "time_preposition": "Time Preposition",
    "select_date_field": "Select date field",
    "subject": "Subject",
    "validation_subject_required": "Please add a subject",
    "validation_days_required": "Please add reminder days",
    "validation_date_property_required": "Please select a date property",
    "validation_employees_required": "Please select at least 1 employee",
    "update_reminder_aria": "update reminder"
  }
}
